module.exports = __webpack_public_path__ + "img/time.e1329df1.jpg";